import api from '../irelandApi'

export const getVoucherTypes = () => (dispatch) => {

  const request = api.get('/api/admin/voucher_types?q[setting]=true');

  dispatch({type: 'GET_VOUCHER_TYPES_PENDING'});

  request.then(response => {
    dispatch({type: 'GET_VOUCHER_TYPES_FULFILLED', payload: response.data.data});
  });

  request.catch(error => Promise.reject(error.response));


  return request;
};

export const getVoucherTypesSetting = () => (dispatch) => {

  const request = api.get('/api/admin/voucher_types?q[setting]=true');

  dispatch({type: 'GET_VOUCHER_TYPES_PENDING'});

  request.then(response => {
    dispatch({type: 'GET_VOUCHER_TYPES_FULFILLED', payload: response.data.data});
  });

  request.catch(error => Promise.reject(error.response));


  return request;
};


// WEBPACK FOOTER //
// ./src/actions/voucher.js